import React from 'react';
import FormDefaultContainer from '../../../Componant/Forms/FormLayout/Default';

const FormDefault = () => {
  return (
    <div className='page-body'>
      <FormDefaultContainer />
    </div>
  );
};

export default FormDefault;
